import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styles from './CLFormValidatedInput.module.scss';
import CLLabel from '../../CLLabel/CLLabel';
import classNames from 'classnames';
import {ErrorShowingType} from '../CLForm.types';
import CLFormErrorIndicator from '../CLFormErrorIndicator/CLFormErrorIndicator';

interface CLFormInputWrapperProps {
  label?: ReactNode;
  inline?: boolean;
  required?: boolean;
  validationError?: string;
  className?: string;
  validationErrorClassName?: string;
  help?: ReactNode;
  labelClassName?: string;
  isInverted?: boolean;
  errorType?: ErrorShowingType;
}

const CLFormValidatedInput: FC<PropsWithChildren<CLFormInputWrapperProps>> = ({
  label,
  inline,
  required,
  children,
  validationError,
  className = '',
  validationErrorClassName = '',
  help,
  labelClassName,
  isInverted,
  errorType = ErrorShowingType.Message,
}) => {
  const borderedWrapperDiv = (
    <div
      className={classNames(styles.border_wrapper, {
        [styles.bordered_wrapper_div]: errorType === ErrorShowingType.Border && validationError,
      })}
    >
      {children}
    </div>
  );
  const content = label ? (
    <div
      className={classNames({[styles.input_wrapper_inline]: inline, [styles.inverted]: isInverted})}
    >
      <CLLabel
        className={classNames(styles.label, labelClassName)}
        withMandatoryMark={required}
        help={help}
      >
        {label}
      </CLLabel>
      {borderedWrapperDiv}
    </div>
  ) : (
    borderedWrapperDiv
  );

  return (
    <div className={classNames(styles.input_wrapper, className)}>
      {content}
      {validationError && errorType === ErrorShowingType.Message && (
        <CLFormErrorIndicator
          validationError={validationError}
          validationErrorClassName={validationErrorClassName}
        />
      )}
    </div>
  );
};

export default CLFormValidatedInput;
